import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './Layout';
import ProtectedRoute from './ProtectedRoute';
import AdminRoute from './AdminRoute';
import WorkspacePage from '../pages/WorkspacePage';
import SettingsPage from '../pages/SettingsPage';
import AdminPanel from '../pages/AdminPanel';
import AdminDashboardPage from '../pages/AdminDashboardPage';
import AdminFeedbackPage from '../pages/AdminFeedbackPage';

/**
 * ProtectedLayout Component
 *
 * Wraps protected routes with Layout component.
 * The main workspace page consolidates Home, Dashboard, and Results
 * into a single-page experience.
 */
const ProtectedLayout: React.FC = () => {
  return (
    <ProtectedRoute>
      <Layout>
        <Routes>
          <Route path="/" element={<WorkspacePage />} />
          {/* Old routes redirect to workspace */}
          <Route path="/dashboard" element={<Navigate to="/" replace />} />
          <Route path="/results" element={<Navigate to="/" replace />} />
          {/* Settings hidden from nav but still accessible */}
          <Route path="/settings" element={<SettingsPage />} />
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminPanel />
              </AdminRoute>
            }
          />
          {/* Super-admin executive dashboard (per-account usage + spend). */}
          <Route
            path="/admin/dashboard"
            element={
              <AdminRoute>
                <AdminDashboardPage />
              </AdminRoute>
            }
          />
          {/* Super-admin customer feedback triage. Split off the exec
              dashboard on 2026-09-09 to keep each page focused. */}
          <Route
            path="/admin/feedback"
            element={
              <AdminRoute>
                <AdminFeedbackPage />
              </AdminRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </ProtectedRoute>
  );
};

export default ProtectedLayout;

